import { useMutation } from '@tanstack/react-query';
import { ENDPOINTS } from 'config/endpoints';
import client from 'utils/clients/client';
import { Request } from 'crono-fe-common/types/request';
import { Response } from 'crono-fe-common/types/response';
import CronoError from 'crono-fe-common/types/error';

export interface DynamicsEnvironment {
  organizationId: string | null;
  tenantId: string | null;
  friendlyName: string | null;
  url: string | null;
}

export interface DynamicsEnvironmentsInput {
  code: string;
}

const DYNAMICS_ENVIRONMENTS_ERROR =
  'Error while listing the Dynamics 365 environments';

// The back end answers some failures with a 200 and `isSuccess: false`, which
// would otherwise reach the caller as a success.
const getDynamicsEnvironments = async (data: DynamicsEnvironmentsInput) => {
  const request: Request = {
    url: ENDPOINTS.dynamics.environments,
    config: {
      method: 'post',
      data: data,
    },
  };

  const response: Response<DynamicsEnvironment[]> = await client(request);

  if (response.data.isSuccess === false) {
    const error: CronoError = {
      message: DYNAMICS_ENVIRONMENTS_ERROR,
      response: {
        status: response.status,
        data: { errors: response.data.errors ?? [] },
      },
    };
    throw error;
  }

  return response;
};

// Feedback is the inline banner on the CRM card, never a toast.
const useDynamicsEnvironments = () =>
  useMutation<
    Response<DynamicsEnvironment[]>,
    CronoError,
    DynamicsEnvironmentsInput
  >(getDynamicsEnvironments, {
    meta: { silentAll: true },
  });

export default useDynamicsEnvironments;
